import { render } from "./BSprojection.vue?vue&type=template&id=4ed949ef&scoped=true"
import script from "./BSprojection.vue?vue&type=script&lang=js"
export * from "./BSprojection.vue?vue&type=script&lang=js"

import "./BSprojection.vue?vue&type=style&index=0&id=4ed949ef&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed949ef"]])

export default __exports__